import { useRef } from 'react';

import { observer } from 'mobx-react';

import { DialogContent } from '../../../../../components/Dialog/DialogUiRedesign/DialogContent';
import { LazySumsubWebSdk } from '../../../../../components/LazySumsubWebSdk';
import { Loader } from '../../../../../components/Loader/Loader';
import type { WizardChildProps } from '../../../../../components/Wizard/types';
import { logToNewRelic } from '../../../../../services/debug';
import { useStores } from '../../../../../stores/useStores';
import { isRecord } from '../../../../../utils/typeGuards';
import type { SofWizardStepFactory } from '../../types';

import styles from './SofProcessView.module.scss';

export const sofProcessViewFactory: SofWizardStepFactory = ({ stepsMapping }) => {
  return observer(function SofProcessView(props: WizardChildProps) {
    const { sofStore } = useStores();

    const userInteractionHappened = useRef(false);

    const handleMessage = (message: string, payload?: Record<string, unknown> | null) => {
      switch (message) {
        case 'idCheck.onStepInitiated':
          userInteractionHappened.current = true;
          break;
        case 'idCheck.onApplicantActionStatusChanged':
          if (userInteractionHappened.current && isRecord(payload?.reviewResult)) {
            if (payload.reviewResult.reviewAnswer === 'GREEN') {
              props.forceStep(stepsMapping.success);
            } else if (
              payload.reviewResult.reviewAnswer === 'RED' &&
              payload.reviewResult.reviewRejectType === 'FINAL'
            ) {
              userInteractionHappened.current = false;
              props.forceStep(stepsMapping.issue);
            }
          }

          break;
        case 'idCheck.onError':
          logToNewRelic(
            'SOF-FE - SumSub WebSDK error',
            `SOF-FE - SumSub WebSDK error: ${JSON.stringify(payload)}`,
            'error',
          );

          if (userInteractionHappened.current) {
            userInteractionHappened.current = false;
            props.forceStep(stepsMapping.issue);
          }
      }
    };

    return (
      <DialogContent className={styles.content}>
        {sofStore.accessToken ? (
          <LazySumsubWebSdk
            accessToken={sofStore.accessToken}
            className={styles.sumSubIframe}
            expirationHandler={async () => {
              try {
                return await sofStore.logIn();
              } catch {
                props.forceStep(stepsMapping.issue);
              }
            }}
            onMessage={handleMessage}
          />
        ) : (
          <Loader />
        )}
      </DialogContent>
    );
  });
};
